import React from 'react';
import DashboardTitle from '../../layout/DashboardTitle';
import { Flex } from 'antd';
import SettingsSidebar from './SettingsSidebar';

interface SettingsProps {
  isUpdateForm?: boolean;
  backUrl?: string;
  children?: React.ReactNode;
}

/**
 * Settings page layout component
 *
 * @param isUpdateForm - Whether to hide the page title
 * @param backUrl - Optional back URL for the sidebar
 * @param children - Content to render in the settings area
 */
const Settings: React.FC<SettingsProps> = ({
  isUpdateForm = false,
  backUrl,
  children,
}) => {
  return (
    <>
      {isUpdateForm ? null : <DashboardTitle title='Settings' />}

      <Flex className='settings-mobile-menu' gap={36}>
        <SettingsSidebar isUpdateForm={isUpdateForm} backUrl={backUrl} />
        <Flex
          vertical={true}
          gap={32}
          style={{ flex: 1, minWidth: 0, width: 'auto' }}
          className='settings-right-content'
        >
          {children}
        </Flex>
      </Flex>
    </>
  );
};

export default Settings;
